import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import LanguageSelector from './LanguageSelector';
import './LandingPage.css';
import Logo from './Logo';
import MessiImage from '../assets/images/Messi.jpg';

function LandingPage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, language } = useTranslation(); // Incluir language para forzar re-render cuando cambie
  return (
    <div className="landing" key={language}>
      <header className="landing__nav">
        <div className="landing__brand">
          <Logo />
          <span className="landing__brandName">RTB Collect</span>
        </div>
        <LanguageSelector />
        <button
          className={`landing__menuButton ${menuOpen ? 'is-active' : ''}`}
          aria-label={t('landing.menuOpen')}
          aria-expanded={menuOpen}
          aria-controls="landing-actions"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div id="landing-actions" className={`landing__actions ${menuOpen ? 'is-open' : ''}`}>
          <a className="btn btn-secondary" href="/how-it-works">{t('landing.howItWorks')}</a>
          <a className="btn btn-secondary" href="/blog">{t('landing.blog')}</a>
          <a className="btn btn-secondary" href="/support">{t('landing.support')}</a>
          <a className="btn btn-primary" href="/login">{t('landing.signIn')}</a>
        </div>
      </header>

        <section
          className="landing__hero"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/azteca.jpeg)`
          }}
        >
          <div className="landing__heroContent">
            <h1>{t('landing.heroTitle')}</h1>
            <p className="landing__heroSubtitle">{t('landing.heroSubtitle')}</p>
            <p className="landing__heroDescription">{t('landing.heroDescription')}</p>
            <div className="landing__cta">
              <a className="btn btn-primary btn--xl btn--nohover" href="/login">{t('landing.startNow')}</a>
            </div>
            <div className="landing__badges">
              <span className="badge badge-secondary">{t('landing.priceAlerts')}</span>
              <span className="badge badge-secondary">{t('landing.trendsMetrics')}</span>
              <span className="badge badge-secondary">{t('landing.stripeIntegrated')}</span>
            </div>
            <div className="landing__heroImage">
              <img src="/rtbs.png" alt="RTBs" />
            </div>
          </div>
        </section>

        <section className="landing__rtbIntro">
          <div className="rtbIntro__content">
            <h2>{t('landing.whatIsRTB')}</h2>
            <p>{t('landing.rtbDescription')}</p>
          </div>
        </section>

        <section className="landing__howItWorks">
          <div className="landing__howItWorksContent">
            <h2>{t('landing.howItWorksTitle')}</h2>
            <div className="howItWorks__steps">
              <div className="step__card card">
                <div className="step__icon">🔗</div>
                <h3>{t('landing.step1Title')}</h3>
                <p>{t('landing.step1Description')}</p>
              </div>
              <div className="step__card card">
                <div className="step__icon">🔔</div>
                <h3>{t('landing.step2Title')}</h3>
                <p>{t('landing.step2Description')}</p>
              </div>
              <div className="step__card card">
                <div className="step__icon">💰</div>
                <h3>{t('landing.step3Title')}</h3>
                <p>{t('landing.step3Description')}</p>
              </div>
            </div>
          </div>
        </section>

      <section className="landing__benefits">
        <div className="landing__benefitsContent">
          <h2>{t('landing.whyChooseTitle')}</h2>
          <div className="benefits__grid">
            <div className="benefit__card card">
              <div className="benefit__icon">📊</div>
              <h3>{t('landing.benefit1Title')}</h3>
              <p>{t('landing.benefit1Description')}</p>
            </div>
            <div className="benefit__card card">
              <div className="benefit__icon">🚨</div>
              <h3>{t('landing.benefit2Title')}</h3>
              <p>{t('landing.benefit2Description')}</p>
            </div>
            <div className="benefit__card card">
              <div className="benefit__icon">📈</div>
              <h3>{t('landing.benefit3Title')}</h3>
              <p>{t('landing.benefit3Description')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="landing__pricing">
        <h2>{t('landing.pricingTitle')}</h2>
        <div className="pricing__grid">
          <div className="pricing__card card">
            <h4>{t('landing.planBasic')}</h4>
            <p className="price">$5 <span style={{fontSize: '0.7em', opacity: 0.8}}>USD</span></p>
            <ul>
              <li>{t('landing.planBasicFeature1')}</li>
              <li>{t('landing.planBasicFeature2')}</li>
              <li>{t('landing.planBasicFeature3')}</li>
              <li>{t('landing.planBasicFeature4')}</li>
            </ul>
            <a className="btn btn-primary" href="/login">{t('landing.startNow')}</a>
          </div>
          <div className="pricing__card pricing__card--highlight card">
            <div className="pricing__badge">{t('landing.mostPopular')}</div>
            <h4>{t('landing.planPremium')}</h4>
            <p className="price">$10 <span style={{fontSize: '0.7em', opacity: 0.8}}>USD</span></p>
            <ul>
              <li>{t('landing.planPremiumFeature1')}</li>
              <li>{t('landing.planPremiumFeature2')}</li>
              <li>{t('landing.planPremiumFeature3')}</li>
              <li>{t('landing.planPremiumFeature4')}</li>
              <li>{t('landing.planPremiumFeature5')}</li>
            </ul>
            <a className="btn btn-primary" href="/login">{t('landing.startNow')}</a>
          </div>
          <div className="pricing__card card">
            <h4>{t('landing.planElite')}</h4>
            <p className="price">$20 <span style={{fontSize: '0.7em', opacity: 0.8}}>USD</span></p>
            <ul>
              <li>{t('landing.planEliteFeature1')}</li>
              <li>{t('landing.planEliteFeature2')}</li>
              <li>{t('landing.planEliteFeature3')}</li>
              <li>{t('landing.planEliteFeature4')}</li>
              <li>{t('landing.planEliteFeature5')}</li>
            </ul>
            <a className="btn btn-primary" href="/login">{t('landing.startNow')}</a>
          </div>
        </div>
      </section>

      <section className="landing__ctaFinal">
        <h2>{t('landing.ctaFinalTitle')}</h2>
        <p>{t('landing.ctaFinalDescription')}</p>
        <a className="btn btn-primary" href="/register">{t('landing.startFree')}</a>
      </section>

      <section className="landing__blog">
        <div className="landing__blogContent">
          <h2>{t('landing.blogTitle')}</h2>
          <p>{t('landing.blogDescription')}</p>
          <div className="landing__blogPreview">
            <div className="blog__previewCard blog__previewCard--centered card">
              <div className="blog__previewImage">
                <img src={MessiImage} alt="Messi" />
              </div>
              <div className="blog__previewContent">
                <span className="badge badge-primary">RTB</span>
                <h4>{t('landing.blogPostTitle')}</h4>
                <p>{t('landing.blogPostDescription')}</p>
                <div className="blog__previewMeta">
                  <span>20 Oct 2024</span>
                  <span>8 min</span>
                </div>
                <a href="/blog/1" className="btn btn-primary">{t('landing.readMore')}</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LandingPage;


